import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useShopNotifications } from "../context/ShopNotificationsContext";
import "../styles/shopNotifications.css";

function timeAgo(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return "";
  const diff = Date.now() - d.getTime();
  const s = Math.floor(diff / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const days = Math.floor(h / 24);
  return `${days}d ago`;
}

export default function ShopNotificationsBell() {
  const nav = useNavigate();
  const { items, unreadCount, markOneRead } = useShopNotifications();
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    function onDoc(e) {
      if (!boxRef.current) return;
      if (!boxRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const top = items.slice(0, 6);

  function getTargetUrl(n) {
    const type = String(n?.type || "").toLowerCase().trim();
    const source = String(n?.meta?.source || "").toLowerCase().trim();

    if (type === "order_returned" || type === "return_status_updated") return "/shop/returns";
    if (type === "order_placed" || type === "order_cancelled" || type === "order_dispute" || type === "order_status_updated") return "/shop/orders";
    if (type === "low_stock") return "/shop/low-stock";
    if (type === "shop_review") return "/shop/reviews";
    if (type === "shop_follow") return "/shop/dashboard/followers";
    if (type === "withdraw_approved" || type === "withdraw_rejected" || type === "bill_payment") return "/shop/finance";
    if (source === "shop_feed") return "/shop/feed";
    if (type.startsWith("message_")) {
      const cid = String(n?.meta?.conversationId || "").trim();
      return cid ? `/shop/messages?c=${encodeURIComponent(cid)}` : "/shop/messages";
    }
    if (type === "like_post" || type === "comment_post" || type === "like_comment" || type === "reply_comment") return "/shop/feed";
    return "/shop/notifications";
  }

  return (
    <div className="sn-bell-wrap" ref={boxRef}>
      <button
        className="sn-bell-btn"
        onClick={() => setOpen((v) => !v)}
        title="Notifications"
        type="button"
      >
        🔔
        {unreadCount > 0 && <span className="sn-badge">{unreadCount > 99 ? "99+" : unreadCount}</span>}
      </button>

      {open && (
        <div className="sn-pop">
          <div className="sn-pop-head">
            <div className="sn-pop-title">Notifications</div>
            <button className="sn-link" onClick={() => { setOpen(false); nav("/shop/notifications"); }}>
              See all
            </button>
          </div>

          {top.length === 0 ? (
            <div className="sn-empty">No notifications yet.</div>
          ) : (
            <div className="sn-list">
              {top.map((n) => {
                const id = n._id || n.id;
                const read = !!(n.readAt || n.read);
                return (
                  <button
                    key={String(id)}
                    type="button"
                    className={`sn-item ${read ? "is-read" : "is-unread"}`}
                    onClick={() => {
                      if (!read) markOneRead(id);
                      setOpen(false);
                      nav(getTargetUrl(n));
                    }}
                  >
                    <div className="sn-item-title">{n.title || n.type || "Notification"}</div>
                    <div className="sn-item-body">
                      {n.message || n.text || n.body || "Open to view"}
                    </div>
                    <div className="sn-item-time">{timeAgo(n.createdAt || n.created_at || n.ts)}</div>
                  </button>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
